// Shared PLP Grid Components
import styled from "@emotion/styled";
import { HEADER_STICKY_OFFSET } from "src/utils/constants";

export const ContentGrid = styled.div`
  display: grid;

  @media (min-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-gap: ${({ theme }) => theme.space?.space8}
      ${({ theme }) => theme.space?.space24};
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    grid-template-columns: minmax(0, 1fr);

    && > * {
      grid-column: 1 / -1;
      min-width: 0;
    }
  }
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-column: span 3;
  min-width: 0;
  gap: ${({ theme }) => theme.space?.space24};

  &.full-width {
    grid-column: span 4;
  }
`;

export const CategoryTreeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.space?.space24};
  grid-column: 1;
  grid-row: 2;

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: none;
  }
`;

export const HeaderSortWrapper = styled.div`
  position: sticky;
  top: ${HEADER_STICKY_OFFSET}px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  grid-row: 1;
  grid-column: 2 / -1;
  padding-block: ${({ theme }) => theme.space?.space24};
  align-self: start;
  background-color: ${({ theme }) => theme.colors.tone.white};
  z-index: 1000;

  &.full-width {
    grid-column: 1 / -1;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    position: sticky;
    top: 58px;
    grid-column: 1 / -1;
    grid-row: auto;
    padding-block: 12px;
    margin-inline: -${({ theme }) => theme.space?.space16};
    padding-inline: ${({ theme }) => theme.space?.space16};
  }
`;

export const StickyTitleContainer = styled.div`
  position: sticky;
  top: ${HEADER_STICKY_OFFSET}px;
  z-index: 100;
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.space?.space16};
  padding-block: ${({ theme }) => theme.space?.space24};
  background-color: ${({ theme }) => theme.colors?.tone.white};
  grid-column: 1;
  grid-row: 1;

  .formatted-title::before {
    content: "“";
  }

  .formatted-title::after {
    content: "”";
  }

  @media (max-width: ${({ theme }) => theme.breakpoints?.md}) {
    display: none;
  }
`;

export const ResultChip = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px ${({ theme }) => theme.space?.space8};
  margin: 4px 0;
  color: ${({ theme }) => theme.colors?.tone.black};
  background-color: ${({ theme }) => theme.colors?.tone.marble};
  font-size: ${({ theme }) => theme.fontSizes?.fontSize14};
  font-weight: 600;
  line-height: 20px;
  border-radius: 16px;
  white-space: nowrap;
`;
